import React from "react";

export default function Course() {
  const html = `<div class="container-md">
<span class="style1"><b>Courses Offered</b></span>
<div class="card shadow-sm">
<div class="justified-text">
<ul class="bullet-list">
<li><b>Bachelor of Education (B.Ed.):</b>A two-year full-time program designed to equip students with both theoretical knowledge and practical teaching skills. The program focuses on developing proficient educators who are capable of handling classroom challenges and fostering student growth.</li>
</ul>
</div>
</div>
</div>`;
  return (
    <div className="container my-4">
      <div dangerouslySetInnerHTML={{ __html: html }} />
    </div>
  );
}
